<template>
    <x-page title="Edit Metric Record">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <metric-record-form id="metric-record-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource" />
        <template #footer>
            <x-submit-button form="metric-record-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { formatForDateInput, handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import MetricRecordForm from './MetricRecordForm.vue'
import MetricRecordFormMixin from './mixins/MetricRecordFormMixin'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        MetricRecordForm,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/metric-records/${this.$route.params.id}`, {
                params: {
                    load: 'values'
                }
            })
            .then(response => {
                const resource = response.data.data
                this.resource = {
                    ...resource,
                    date: formatForDateInput(resource.date),
                    values: this.parseServerMetrics(resource.values),
                }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.put(`/api/metric-records/${this.$route.params.id}`, {
                ...fields,
                values: this.formatMetrics(fields.values),
            })
            .then(() => {
                this.$notify({
                    type: 'success',
                    title: `Berhasil`,
                    text: `${fields.date} updated!`,
                })
                this.$router.back()
            })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
    mixins: [
        MetricRecordFormMixin,
    ],
}
</script>